import React from "react";
import { Chip } from "@mui/material";

const STATUS_STYLE_MAP = {
  active: { label: "Active", bg: "#dcfce7", color: "#166534" },
  enabled: { label: "Enabled", bg: "#dcfce7", color: "#166534" },
  disabled: { label: "Disabled", bg: "#e5e7eb", color: "#374151" },
  locked: { label: "Locked", bg: "#fee2e2", color: "#991b1b" },
  pending: { label: "Pending", bg: "#ffedd5", color: "#9a3412" },
};

const getStatus = (status, enabled, locked) => {
  if (typeof enabled === "boolean" || typeof locked === "boolean") {
    if (locked) return "locked";
    return enabled ? "active" : "disabled";
  }
  if (!status) return "disabled";
  return String(status).toLowerCase();
};

const StatusChip = ({ status, enabled, locked }) => {
  const key = getStatus(status, enabled, locked);
  const config = STATUS_STYLE_MAP[key] || {
    label: status || "Unknown",
    bg: "#e2e8f0",
    color: "#1f2937",
  };

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        fontWeight: 600,
        backgroundColor: config.bg,
        color: config.color,
      }}
    />
  );
};

export default StatusChip;
